import BackToHome from "./BackToHome"
import Armadietto from "./armadietto";
import Buco from "./buco";
import Cassapanca from "./cassapanca";
import Marrone from "./marrone";
import Puntozero from "./puntozero";
import Rodolfo from "./rodolfo";
import { useParams } from "react-router-dom";

function Pagina () {
    const { pagina } = useParams<{ pagina: string }>();
    const componente = {armadietto: <Armadietto/>,
                        buco: <Buco />,
                        cassapanca: <Cassapanca />,
                        marrone: <Marrone />,
                        puntozero: <Puntozero />,
                        rodolfo: <Rodolfo />,}[pagina ?? ""];  
    return (
        <div>
        {componente ?? <p>Pagina non trovata</p>}  
        <BackToHome />
        </div>
    )
}

export default Pagina;